// Batches the cashier chose for a cart line (item.batchPicks, quantities in the
// item's STOCK unit). A choice only counts while it still adds up to the
// quantity in the cart: change the quantity and the line falls back to
// "automatic, nearest expiry first" (or the picker is asked again at checkout).

const round2 = (n) => Math.round(Number(n) * 100) / 100;

export const picksTotal = (picks) =>
  round2((Array.isArray(picks) ? picks : []).reduce((s, p) => s + (Number(p?.qty) || 0), 0));

/** The line's chosen batches if they still cover `needed`, else null. */
export const validPicks = (item, needed) => {
  const picks = item?.batchPicks;
  if (!Array.isArray(picks) || !picks.length) return null;
  return Math.abs(picksTotal(picks) - round2(needed)) < 0.01 ? picks : null;
};

/** Stock-unit quantity a cart line needs (always positive). */
export const neededInStockUnit = (getConvertedQuantity, item) => {
  const stockUnitId = item?.units?.stock?.unit?._id;
  if (!stockUnitId) return 0;
  return Math.abs(Number(getConvertedQuantity(item, "sale", stockUnitId)) || 0);
};
